import { useEffect, useMemo, useRef } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import {listaProcessamentos} from "./processamentos";
import { useProcessamentos } from "../../../../../contexts/ProcessamentosProvider";

const NENHUM = [];

export function useGruposEmProcessamento(id_empresa) {
    const queryClient = useQueryClient();
    const { itens } = useProcessamentos();

    const { data } = useQuery({
        queryKey: ['processamentosAtivos', String(id_empresa ?? '')],
        queryFn: () => listaProcessamentos(id_empresa),
        enabled: !!id_empresa,
        refetchInterval: (query) => (query.state.data?.length ? 5000 : 15000),
        refetchOnWindowFocus: true,
    });

    const ativos = Array.isArray(data?.data?.data) ? data.data.data : NENHUM;
    const anteriores = useRef(new Set());

    useEffect(() => {
        const atuais = new Set(ativos.map((processamento) => processamento.id));
        const algumTerminou = [...anteriores.current].some((id) => !atuais.has(id));

        anteriores.current = atuais;

        if (algumTerminou) {
            queryClient.invalidateQueries({ queryKey: ['reportOfGHEs'] });
        }
    }, [ativos, queryClient]);

    return useMemo(() => {
        const mapa = new Map();

        ativos.forEach((processamento) => {
            mapa.set(Number(processamento.id_referencia), {
                id_processamento: processamento.id,
                usuario: processamento.usuario,
                progresso: processamento.progresso,
                meu: false,
            });
        });

        itens
            .filter((item) => item.status === 'processando' && item.id_grupo)
            .forEach((item) => {
                const doServidor = mapa.get(item.id_grupo);

                mapa.set(item.id_grupo, {
                    id_processamento: item.id,
                    usuario: doServidor?.usuario ?? null,
                    progresso: item.progresso ?? doServidor?.progresso ?? null,
                    meu: true,
                });
            });

        return mapa;
    }, [ativos, itens]);
}